/* eslint-disable react/display-name */
import Button from 'components/Button/Button';
import moment from 'moment';
import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { FulfillmentNote } from 'types/schema';
import messages from '../OrdersPage/messages';

const Header = styled.h1`
  color: #343538;
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  margin: 0;
`;

const Container = styled.div`
  position: relative;
  display: flex;
  margin: 37px 0 20px;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 767px) {
    padding: 0 10pt;
    margin: 15px 0 20px;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  @media (max-width: 767px) {
    display: none;
  }
`;

const ButtonText = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #343538;
`;

// const Icon = styled(SVGIcon)`
//   width: 16px;
//   height: 16px;
// `;

const ActionButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 16px;
  min-width: 100px;
`;

const RateButton = styled(ActionButton)`
  background-color: #43a047;

  &:hover,
  &:focus,
  &:active {
    background-color: #43a047 !important;
  }
`;

const RateButtonText = styled(ButtonText)`
  color: #fff;
`;

// const ActionButtonResponsive = styled(ActionButton)`
//   @media (max-width: 767px) {
//     display: none;
//   }
// `;

interface FulfillmentNoteDetailPageHeaderProps {
  onBulkReOrder: (data: { storeId: string; orderIds: string[] }) => void;
  asComponent?: any;
  semibold?: boolean;
  children?: ReactNode;
  fulfillmentNote: FulfillmentNote;
  store: string;
  onOpenModal: (note: FulfillmentNote) => void;
}

export default function (props: FulfillmentNoteDetailPageHeaderProps) {
  const { asComponent, semibold, fulfillmentNote, store, onBulkReOrder, onOpenModal, ...delegated } = props;

  const shouldShowRateButton =
    fulfillmentNote.firstOrder?.status === 'DELIVERED' &&
    moment().diff(moment(fulfillmentNote.orderDateTime), 'days') <= 7 &&
    !fulfillmentNote.feedback?.rating;

  return (
    <Container {...delegated}>
      <Header semibold={semibold} as={asComponent}>
        {props.children}
      </Header>

      <ButtonWrapper>
        {/* {fulfillmentNote?.firstOrder?.status === OrderStatus.Delivered && (
          <ActionButtonResponsive>
            <Icon src={pdfIcon} />
            <ButtonText>
              <FormattedMessage {...utilMessages.print} />
            </ButtonText>
          </ActionButtonResponsive>
        )} */}

        <ActionButton onClick={() => onBulkReOrder({ orderIds: fulfillmentNote.orderIds, storeId: store })}>
          <ButtonText>
            <FormattedMessage {...messages.reOrder} />
          </ButtonText>
        </ActionButton>

        {shouldShowRateButton ? (
          <RateButton onClick={() => onOpenModal(fulfillmentNote)}>
            <RateButtonText>
              <FormattedMessage {...messages.rate} />
            </RateButtonText>
          </RateButton>
        ) : null}
      </ButtonWrapper>
    </Container>
  );
}
